export const messages = {
  page: {
    header: {
      id: 'healthSummary.Email.Page.Header',
      defaultMessage: 'Send by Email',
    },
  },
  explanation: {
    primary: {
      id: 'healthSummary.Email.Explanation.Primary',
      defaultMessage:
      `To email your Health Summary to a Healthcare Provider, enter the information below.
      Note that standard email is not a secure way of transmitting private health information.`,
    },
    secondary: {
      id: 'healthSummary.Email.Explanation.Secondary',
      defaultMessage: 'Your Health Summary will be automatically attached to this email when sent.',
    },
  },
  sender: {
    label: {
      id: 'healthSummary.Email.Sender.Label',
      defaultMessage: 'From',
    },
    placeholder: {
      id: 'healthSummary.Email.Sender.Placeholder',
      defaultMessage: 'My email address',
    },
  },
  recipient: {
    label: {
      id: 'healthSummary.Email.Recipient.Label',
      defaultMessage: 'To',
    },
    placeholder: {
      id: 'healthSummary.Email.Recipient.Placeholder',
      defaultMessage: 'Recipient\'s email address',
    },
  },
  body: {
    label: {
      id: 'healthSummary.Email.Body.Label',
      defaultMessage: 'Message',
    },
    placeholder: {
      id: 'healthSummary.Email.Body.Placeholder',
      defaultMessage: 'Type your message here (optional)...',
    },
  },
  send: {
    label: {
      id: 'healthSummary.Email.Send.Label',
      defaultMessage: 'Send',
    },
  },
  cancel: {
    label: {
      id: 'healthSummary.Email.Cancel.Label',
      defaultMessage: 'Cancel',
    },
  },
};
